import { BaseFillMenuItemState } from "./BaseFillMenuItemState";




export class BfxBlotterOrdersContextMenuItemDetailFillState extends BaseFillMenuItemState {}
